<script>
import FsLightbox from "fslightbox-vue";

const baseUrl = process.env.NODE_ENV === 'production' ? '/api' : 'http://192.168.100.72:9090'
export default {
  name: 'ProductImage',
  components: {FsLightbox},
  props: {
    id: Number
  },
  data: function() {
    return {
      toggler: false
    }
  },
  methods: {
    getImageUrl(id) {
      return `${baseUrl}/image/${id}`
    }
  }
}
</script>

<template>
  <div>
    <FsLightbox :toggler="toggler" :sources="[getImageUrl(id)]" ></FsLightbox>
    <img  @click="toggler = !toggler" class="card-image" :src="getImageUrl(id)" alt=""/>
  </div>
</template>

<style scoped>
.card-image {
  object-fit: cover;
  width: 100%;
  height: 100%;
  display: block;
}
</style>